// extracted by mini-css-extract-plugin
export default {"relativeTime":"vyCksOKVM6Zo6hw3bOLF","highlight":"aPG5CQCdRfFuROZ4ltzx"};